<template>
	<Row>
		<Col span="16" offset="8">
			<TypographyText type="secondary">
				<i18n-t keypath="base-stations-edit.fields.protocolNtripHelp" tag="span" scope="global">
					<template #ntrip>
						<TypographyText type="secondary" code>ntrip</TypographyText>
					</template>
				</i18n-t>
			</TypographyText>
		</Col>
	</Row>
</template>

<script>
import { Row, Col, TypographyText } from 'ant-design-vue';

export default {
	components: {
		Row, Col, TypographyText,
	}
};
</script>
